// extracted by mini-css-extract-plugin
export var draftAttachmentContainer = "_ih-0";
export var fileCarousel = "_ih-2";
export var removeFileButton = "_ih-1";